<template>
	<div class="v-container">
		<div id="viewersDiv" class="viwers-div">
			<div id="pano" class="pano" :class="{'pano-left':isSplitScreen,fullscreen:groupList[0] && groupList[0].id == groupId && isShowPolylineDraw}"></div>
			<div v-if='isSplitScreen' id="panoRight" class="pano pano-right"></div>
			<div v-if='isSplitScreen' class="time-line time-line-left">
				<div class="active">
				<span>{{ displayGroup.record_time }} </span>
					<i class="iconfont icon-arrow-bottom"></i>
				</div>
				<div class="lists">
					<div class="box">
						<div class="item" v-for="(item,index) in groupList" :key="item.id" :class="{active:item.id == displayGroup.id,disabled:item.id == groupIdRight}" @click="changeGroupLeft(item.id)">
							<i v-if="index == 0 && !isMobile" class="iconfont icon-flag"></i>
							<span>{{ item.record_time }}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-if='isSplitScreen' class="time-line time-line-right">
				<div class="active">
					<span>{{ groupRightRecordTime }} </span> <i class="iconfont icon-arrow-bottom"></i>
				</div>
				<div class="lists">
					<div class="box">
						<div class="item" v-for="item in groupList" :key="item.id" :class="{active:item.id == groupIdRight,disabled:item.id == displayGroup.id}" @click="changeGroupRight(item.id)">{{ item.record_time }}</div>
					</div>
				</div>
			</div>
			<div v-if='isSplitScreen' class="btn-exit-split" :class="{floor:!isShowSceneBar}" @click="splitScreen">退出分屏</div>
		</div>

		<img v-if="isShowLoading" class="loading-img" src="../../assets/images/loading.png" />

		<div class="fixed-box" id="fixed-box" title="标记问题">
			<template v-if="!isMobile">
				<template v-if="userInfo.level != 3">
					<template v-if="groupList[0]">
						<div v-if="groupList[0].id == groupId" class="fixed-item">
							<i class="icon iconfont icon-flag" @click="isShowPolylineList = true"></i>
						</div>
					</template>
				</template>
			</template>

			<div v-if="settings.switch_scene" class="fixed-item" title="显示/隐藏导航条" @click="isShowSceneBar = !isShowSceneBar">
				<i class="icon iconfont icon-category"></i>
			</div>
			<template v-if="!isSplitScreen">
				<div class="fixed-item" title="显示/隐藏覆盖物" @click="toggleHotspot">
					<i class="icon iconfont" :class="isShowHotspot ? 'icon-view' : 'icon-view-disabled'"></i>
				</div>
				<div v-if="!isMobile" class="fixed-item" title="截屏" @click="krp.call('makeScreenshot()')">
					<i class="icon iconfont icon-camera"></i>
				</div>
			</template>
			<div v-if="!isMobile && groupList.length > 1" class="fixed-item" title="分屏对比" @click="splitScreen">
				<i class="icon iconfont icon-split"></i>
			</div>
		</div>

		<polyline-status-bar v-if="isShowUi" />

		<polyline-list v-if="isShowPolylineList" :show.sync="isShowPolylineList" @init="
        (x, y) => {
          mouseX = x;
          mouseY = y;
        }
      " />
		<polyline-draw v-if="isShowPolylineDraw" :show.sync="isShowPolylineDraw" :mode="polylineMode" />
		<comment-dialog v-if="is_show_comment" :show.sync="is_show_comment" :comment_id="comment_id" />

		<scene-bar ref="sceneBar" v-show="isShowSceneBar" :group-id-right="groupIdRight" />
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import polylineList from './components/polyline-list';
	import polylineDraw from './components/polyline-draw';
	import commentDialog from './components/comment-dialog';
	import sceneBar from './components/scene-bar';
	import polylineStatusBar from './components/polyline-staus-bar';
	import polylineInfo from './polyline'
	import build from './build';

	export default {
		components: {
			polylineList,
			commentDialog,
			polylineDraw,
			sceneBar,
			polylineStatusBar
		},

		data() {
			return {
				krp: '',
				loading: false,
				polylineInfo,
				isShowUi: false,
				groupId: '',
				groupIdRight: '',
				jsonXml: null, //xml-json
				works_id: this.$route.query.id,
				isShowLoading: true,
				groupList: [],
				sceneList: [],
				mid: this.$route.query.material_id,
				material_id: '', //当前场景素材id
				is_show_comment: false, //是否显示评论
				isMobile: this.isMobile, //手机访问
				is_gyro_open: false,
				unread_count: 0,
				isShowMessage: false,
				isShowPolylineList: false,
				isShowPolylineDraw: false,
				mouseX: 0,
				mouseY: 0,
				polylineMode: 1, //折线绘制方式
				isShowSceneBar: true, //场景切换工具条
				groupSceneList: [], //最新分组场景
				isShowHotspot: true,
				settings: {
					background_media_id: '',
					explain_media_id: '',
					switch_planet: true,
					switch_scene: true,
					switch_audio_background: false,
					switch_audio_explain: false,
				},
				userPolylineList: [],
				isSplitScreen: false
			};
		},

		computed: {
			...mapState('user', ['userInfo']),
			isWx() {
				return this.$route.query.from == 'm';
			},
			displayScene() {
				return this.sceneList.find((item) => item.id == this.mid) || {};
			},
			displayGroup() {
				return this.groupList.find((item) => item.id == this.displayScene.group_id) || {};
			},
			groupRightRecordTime() {
				let group = this.groupList.find(item => item.id == this.groupIdRight);
				return group ? group.record_time : ''
			}
		},

		provide() {
			return {
				getGroupList: () => this.groupList,
				getSceneList: () => this.sceneList,
				getDisplayGroup: () => this.displayGroup,
				getMid: () => this.mid,
				changeGroup: this.changeGroup,
				loadPanoScene: this.loadPanoScene,
				renderPolyline: this.renderPolyline
			};
		},

		created() {
			if (this.$route.query.title) {
				document.title = this.$route.query.title;
			}
			window.krpjs.showLoading = () => {
				this.isShowLoading = true;
			};
			window.krpjs.hideLoading = () => {
				this.isShowLoading = false;
			};
			window.krpjs.showUi = () => {
				this.isShowUi = true;
			}
			window.krpjs.showPolyline = this.showPolyline;
			window.krpjs.showComment = this.showComment;
			window.krpjs.hsHandle = this.hsHandle;
			this.getGroupList();
		},

		watch: {
			mid: function () {
				this.isShowHotspot = true;
			},
		},

		methods: {
			hsHandle(materialId, id) {
				if (this.isSplitScreen) {
					let sceneListRight = this.groupList.find(item => item.id == this.groupIdRight).scene_list;
					let sceneData = sceneListRight.find(item => item.id == materialId);
					if (sceneData) {
						let idIndex = sceneData.spot_list.findIndex(item => item.id == id);
						materialId = this.getToGroupMid(sceneData, this.displayGroup);
						id = this.displayScene.spot_list[idIndex].id;
					}
				}
				let row = this.sceneList.find((item) => item.id == materialId).spot_list.find((item) => item.id == id);
				let blend = this.krp.get(`blendmodes`).getArray()[row.ext.switch_type - 1].blend;
				this.loadPanoScene(row.ext.material_id, blend);
			},

			//获取场景列表
			async getGroupList() {
				this.loading = true;
				try {
					let res = await this.api.vr.show({works_id: this.works_id});
					let groupId = this.mid ? (await  await this.api.material.getMaterialInfo({material_id:this.mid})).data.group_id : res.data.group_list[0].id;
					let groupIndex = this.mid ? res.data.group_list.findIndex(item=>item.id == groupId) : 0;
					let res2 = await this.api.vr.getSceneData({works_id: this.works_id, group_id: groupId});
					this.groupList = res.data.group_list;
					this.groupId = groupId;
					this.groupList[groupIndex].scene_list = res2.data;
					this.sceneList = res2.data;
					this.mid = this.mid || this.sceneList[0].id;
					this.buildKrp();
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			async buildKrp(flags, loaddone) {
				try {
					let settings = await build.getSetting(this.works_id);
					this.settings = Object.assign(this.settings, settings);
					this.jsonXml = this.jsonXml || await build.getXml(this.settings);
					this.jsonXml.krpano.scene = build.getSceneXml(this.sceneList, this.$route.query);
					if (!this.krp) {
						this.krp = await build.getKrp(this.mid, this.$route.query);
						this.$store.dispatch('krp/setKrpDom', this.krp);
					}
					build.loadPanoXml(this.jsonXml, this.krp, flags, loaddone);
				} catch (e) {
					console.error(e);
				}
			},

			//切换分组
			async changeGroup(groupId) {
				if (groupId == this.displayGroup.id) {
					return;
				}
				this.groupId = groupId;
				let toGroup = await this.getToGroup(this.groupList, groupId, this.works_id);
				this.mid = this.getToGroupMid(this.displayScene, toGroup);

				let flags = 'KEEPIMAGE | KEEPVIEW | KEEPLIMITS | KEEPLOOKAT | KEEP3D | KEEPPLUGINS | KEEPHOTSPOTS';
				let loaddone = `set(settings.is_loaded,true);loadscene(${this.mid},null,MERGE | KEEPVIEW,OPENBLEND(0.5, 0.0, 0.75, 0.05, linear));`;
				this.buildKrp(flags, loaddone);
			},

			//获取指定分组
			async getToGroup(groupList, groupId, worksId) {
				try {
					let toGroup = groupList.find((item) => item.id == groupId);
					if (!toGroup.scene_list || toGroup.scene_list.length == 0) {
						let res = await this.api.vr.getSceneData({works_id: worksId, group_id: groupId});
						toGroup.scene_list = res.data;
					}
					this.sceneList = this.groupList.reduce((all, next) => [...all, ...(next.scene_list || [])], []);
					return toGroup
				} catch (e) {
					console.error(e)
				}
			},

			//获取指定分组-场景id
			getToGroupMid(displayScene, toGroup) {
				let fromRelativeMid = displayScene.top_id || displayScene.id;
				let toScene = toGroup.scene_list.find((item) => fromRelativeMid == (item.top_id || item.id));
				return toScene ? toScene.id : toGroup.scene_list[0].id;
			},

			//场景切换
			loadPanoScene(id, blend = 'OPENBLEND(0.5, 0.0, 0.75, 0.05, linear)') {
				this.mid = id;
				this.krp.call(`loadscene(${id},null,MERGE,${blend})`);
				if (this.isSplitScreen) {
					let toGroup = this.groupList.find(item => item.id == this.groupIdRight);
					let mid =  this.midRight = this.getToGroupMid(this.displayScene, toGroup);
					document.getElementById(this.krp.get('syncviewer')).call(`loadscene(${mid},null,MERGE,${blend})`)
				}
			},

			//显示隐藏热点
			toggleHotspot() {
				this.isShowHotspot = !this.isShowHotspot;
				if (this.isShowHotspot) {
					this.krp.call('show_hotspot()');
					this.userPolylineList.forEach((item) => {
						this.krp.call(`set(hotspot[${item.name}_delete].visible,${item.is_own == 1})`);
					});
				} else {
					this.krp.call('hide_hotspot()');
				}
			},

			async showPolyline(isRight) {
				let krp = isRight ? document.getElementById(this.krp.get('syncviewer')) : this.krp;
				let materialId = isRight ? this.midRight : this.mid;
				try {
					let res = await this.api.polyline.newLists({
						works_id: this.works_id,
						material_id: materialId,
					});
					this.userPolylineList = res.data;
					res.data.forEach((item) => {
						this.renderPolyline(item,krp);
					});
				} catch (e) {
					console.error(e);
				}
			},

			//渲染折线
			// item.status 1代理中 2处理完成 3确认通过
			// item.to_user_id 指派人id
			renderPolyline(item,krp) {
				krp = krp || this.krp;
				let name = item.name;
				let color = polylineInfo[item.status].color16;
				color = item.kind === 1 ? this.utils.rgbaTo16('rgba(255, 255, 255, 1)').color : color;
				color = item.kind === 2 ? this.utils.rgbaTo16('rgba(147, 37, 156,1)').color : color;
				krp.call(`addhotspot(${name});`);
				krp.call(`set(hotspot[${name}].borderwidth,${item.width});`);
				krp.call(`set(hotspot[${name}].bordercolor,${color});`);
				krp.call(`set(hotspot[${name}].polyline,true);`);
				krp.call(`set(hotspot[${name}].enabled,false);`);
				krp.call(`set(hotspot[${name}].handcursor,false);`);
				item.points.forEach((point, pointIndex) => {
					krp.call(`set(hotspot[${name}].point[${pointIndex}].ath,${point.ath});`);
					krp.call(`set(hotspot[${name}].point[${pointIndex}].atv,${point.atv});`);
				});

				this.renderPolylineDelete(item,krp);
				this.renderPolylineComment(item,krp);
			},

			//渲染折线-删除
			renderPolylineDelete(item,krp) {
				let name = item.name + '_delete';
				krp.call(`addhotspot(${name});`);
				krp.call(`set(hotspot[${name}].url,'/krpano/images/skin/ployline-close.png');`);
				krp.call(`set(hotspot[${name}].ath,${item.points[0].ath});`);
				krp.call(`set(hotspot[${name}].atv,${item.points[0].atv});`);
				krp.call(`set(hotspot[${name}].visible,false);`);
				krp.call(`set(hotspot[${name}].width,30);`);
				krp.call(`set(hotspot[${name}].height,30);`);
				krp.call(`set(hotspot[${name}].css,font-size:14px;text-align:center;`);
				krp.call(`set(hotspot[${name}].onclick,js(krpjs.deletePolyline(${item.name},${item.id})));`);
			},

			//渲染折线-评论
			renderPolylineComment(options,krp) {
				let name = options.name + '_comment';
				let pname = name + '_position';
				krp.call(`addhotspot(${name});`);
				krp.call(`set(hotspot[${name}].type,text);`);
				krp.call(`set(hotspot[${name}].html,${options.nickname}：${options.content.replace('系统检测', '')} [br] ${options.create_time} `);
				krp.call(`set(hotspot[${name}].ath,${options.ath || options.comment_ath});`);
				krp.call(`set(hotspot[${name}].atv,${options.atv || options.comment_atv});`);
				krp.call(`set(hotspot[${name}].edge,bottom);`);
				krp.call(`set(hotspot[${name}].padding,10);`);
				krp.call(`set(hotspot[${name}].oy,-30);`);
				krp.call(`set(hotspot[${name}].css,fontSize:12px);`);
				krp.call(`set(hotspot[${name}].bgcolor,${this.utils.rgbaTo16('rgba(255,255,255,1)').color});`);
				krp.call(`set(hotspot[${name}].bgalpha,0.6);`);
				krp.call(`set(hotspot[${name}].roundedge,8);`);
				krp.call(`set(hotspot[${name}].onclick,js(window.krpjs.showComment(${options.comment_id})));`);

				krp.call(`addhotspot(${pname});`);
				krp.call(`set(hotspot[${pname}].url,'/krpano/images/preview/comment-line.png');`);
				krp.call(`set(hotspot[${pname}].width,20);`);
				krp.call(`set(hotspot[${pname}].height,60);`);
				krp.call(`set(hotspot[${pname}].scale,0.5);`);
				krp.call(`set(hotspot[${pname}].alpha,0.7);`);
				krp.call(`set(hotspot[${pname}].edge,bottom);`);
				krp.call(`set(hotspot[${pname}].ath,${options.ath || options.comment_ath});`);
				krp.call(`set(hotspot[${pname}].atv,${options.atv || options.comment_atv});`);
				krp.call(`set(hotspot[${pname}].onclick,js(window.krpjs.showComment(${options.comment_id})));`);
			},

			//显示-回复
			showComment(id) {
				if (this.isWx) {
					parent.toCommentDetail(id);
				} else {
					this.comment_id = id;
					this.is_show_comment = true;
				}
			},

			//分屏对比
			async splitScreen() {
				if (this.isSplitScreen) {
					this.isSplitScreen = false;
					this.groupIdRight = '';
					removepano(this.krp.get('syncviewer'));
					return
				}
				this.isSplitScreen = true;
				await this.$nextTick();

				let groupIndex = this.groupList.findIndex(item => item.id == this.groupId);
				let toGroup = this.groupList[groupIndex + 1] || this.groupList[groupIndex - 1];
				await this.loadRightPano(toGroup.id)
			},

			async loadRightPano(groupId) {
				let toGroup = this.groupList.find(item => item.id == groupId);
				this.groupIdRight = toGroup.id;
				await this.getToGroup(this.groupList, toGroup.id, this.works_id);
				let mid = this.midRight = this.getToGroupMid(this.displayScene, toGroup);
				let jsonXml = JSON.parse(JSON.stringify(this.jsonXml));
				jsonXml.krpano.settings._is_planet = false;
				jsonXml.krpano.settings._isRight = true;
				jsonXml.krpano.scene = build.getSceneXml(this.sceneList, this.$route.query);
				let krp = document.getElementById(this.krp.get('syncviewer'));
				if (!krp) {
					krp = await build.getKrp(mid, {}, 'panoRight');
					build.loadPanoXml(jsonXml, krp);
				} else {
					let flags = 'KEEPIMAGE | KEEPVIEW | KEEPLIMITS | KEEPLOOKAT | KEEP3D | KEEPPLUGINS | KEEPHOTSPOTS';
					let loaddone = `set(settings.is_loaded,true);loadscene(${mid},null,MERGE | KEEPVIEW,OPENBLEND(0.5, 0.0, 0.75, 0.05, linear));`;
					build.loadPanoXml(jsonXml, krp, flags, loaddone);
				}

			},

			changeGroupLeft(groupId) {
				if (this.displayGroup.id == groupId || this.groupIdRight == groupId) {
					return
				}
				this.$refs.sceneBar.doChangeGroup(groupId);
			},

			changeGroupRight(groupId) {
				if (this.displayGroup.id == groupId || this.groupIdRight == groupId) {
					return
				}
				this.loadRightPano(groupId)
			}
		},
	};
</script>

<style scoped>
	.v-container {
		background: #000;
		position: relative;
		overflow: hidden;
	}

	.viwers-div {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
	}

	.pano {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
	}

	.pano-left {
		right: 50%;
	}

	.pano-left.fullscreen {
		right: 0;
		transition: all 0.5s ease;
		z-index: 9;
	}

	.pano-right {
		left: 50%;
	}

	.pano-right.fullscreen {
		left: 0;
		transition: all 0.5s ease;
		z-index: 9;
	}

	.loading-img {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
		width: 56px;
		height: 24px;
	}

	.fixed-box {
		position: fixed;
		right: 10px;
		top: 10px;
		display: none;
		z-index: 10;
	}

	.fixed-box .fixed-item {
		margin-bottom: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.fixed-box .fixed-item .icon {
		width: 34px;
		height: 34px;
		cursor: pointer;
		margin-bottom: 5px;
		background: rgba(0, 0, 0, 0.3);
		color: #fff;
		border: 1px solid #9d9993;
		border-radius: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		opacity: 0.8;
	}

	.fixed-box .fixed-item .label {
		font-size: 12px;
		color: #fff;
	}

	.fixed-item .unread {
		position: absolute;
		display: flex;
		background: red;
		color: #fff;
		border-radius: 100%;
		right: -6px;
		top: -6px;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		width: 25px;
		height: 25px;
		transform: scale(0.8);
	}

	.time-line {
		position: absolute;
		width: 120px;
		color: #fff;
		top: 10px;
		left: 10px;
		font-size: 12px;

	}

	.time-line > .active {
		height: 26px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		background: rgba(0, 0, 0, 0.6);
	}

	.time-line > .active .iconfont {
		font-size: 12px;
		position: absolute;
		top: 50%;
		right: 0;
		transform: translate(-8px, -50%) scale(0.7);
	}

	.time-line-right {
		left: 50%;
		margin-left: 10px;
	}

	.time-line .lists {
		position: absolute;
		top: 100%;
		width: 100%;
		display: none;
		padding-top: 4px;
	}

	.time-line .lists .box {
		background: rgba(0, 0, 0, 0.6);
		padding: 0 10px;
		border-radius: 4px;
	}

	.time-line:hover .lists {
		display: block;
	}

	.time-line .lists .item {
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		border-bottom: 1px solid #fff;
		position: relative;
	}

	.time-line .lists .item.active {
		color: #409eff;
		cursor: not-allowed;
	}

	.time-line .lists .item.disabled {
		color: #7a7a7a;
		cursor: not-allowed;
	}

	.time-line .lists .item:last-child {
		border-bottom: 0;
	}

	.time-line .lists .item .iconfont{
		position: absolute;
		font-size: 12px;
		top:50%;
		transform: translateY(-50%);
		color: #fff;
		right:0;
	}

	.time-line .lists .item.active .iconfont{
		color: #409eff;
	}


	.btn-exit-split {
		position: absolute;
		width: 100px;
		height: 30px;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		left: 50%;
		transform: translateX(-50%);
		bottom: 110px;
	}

	.btn-exit-split.floor {
		bottom: 10px;
	}

</style>
